export interface RestbestandRowApiModel {
  barcode: string;
  status: string;
  statusZeitpunkt: string | null;
  bestandsalterNdl?: number | null;
  bestandsalterSat?: number | null;
  bestandsalterGesamt?: number | null;
}

export default class RestbestandRow {
  constructor(
    public readonly barcode: string,
    public readonly status: string,
    public readonly statusZeitpunkt: string | null,
    public readonly bestandsalterNdl: number | null = null,
    public readonly bestandsalterSat: number | null = null,
    public readonly bestandsalterGesamt: number | null = null
  ) {}

  static fromJson(json: RestbestandRowApiModel): RestbestandRow {
    return new RestbestandRow(
      json.barcode,
      json.status,
      json.statusZeitpunkt,
      json.bestandsalterNdl ?? null,
      json.bestandsalterSat ?? null,
      json.bestandsalterGesamt ?? null
    );
  }

  key(): string {
    return `${this.barcode}-${this.status}-${this.statusZeitpunkt ?? ''}`;
  }
}
